export default __webpack_public_path__ + "static/media/man_lang_seite.ddbfa08d.jpg";